export const BASIC = 'L'


// WEBPACK FOOTER //
// ./src/constants/DateFormat.tsx